/* eslint-disable no-param-reassign */
import latestVersion from 'latest-version';
import { ImportMap } from './types.js';

export async function transformImportMap(
  importMap: ImportMap,
  headLinks: string,
  npmVersionSemver: string,
) {
  const importMapPackages = [
    ...new Set(
      Object.keys(importMap.imports)
        .filter(i => i.startsWith('@digital-realty') && !i.endsWith('.js'))
        .map(i => i.replace(/\/+$/, ''))
        .map(i => i.replace('/IxGridNav', '')),
    ),
  ];

  const latestVersions = [];
  const cdnRegex = /@(\d+\.\d+\.\d+)/;

  for (const importMapPackage of importMapPackages) {
    // eslint-disable-next-line no-await-in-loop
    const latestNpmVersion = await latestVersion(importMapPackage, {
      version: npmVersionSemver,
    });
    latestVersions.push({ name: importMapPackage, version: latestNpmVersion });
    console.log(`Latest version of ${importMapPackage}: ${latestNpmVersion}`);
  }

  const themeVersion = latestVersions.find(
    v => v.name === '@digital-realty/theme',
  );
  if (themeVersion) {
    headLinks = headLinks.replace(/\|\|.*?\|\|/g, `@${themeVersion.version}`);
  }

  for (const value of Object.keys(importMap.imports)) {
    const foundPackage = latestVersions.find(
      p =>
        value.startsWith(`${p.name}/`) ||
        value === p.name ||
        value.startsWith(`{{NPM_CDN}}/${p.name}@^`),
    );
    if (foundPackage) {
      // eslint-disable-next-line no-param-reassign
      importMap.imports[value] = importMap.imports[value].replace(
        cdnRegex,
        `@${foundPackage.version}`,
      );
    }
  }

  return headLinks;
}
